import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment'

import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import { closeErrorModal } from '../../store/actions/errorModalAction';

interface ErrorModalContainerState { };

interface ErrorModalContainerProps  {
  errorModal: {opened: boolean, error: any};
  closeModal: () => void;
};

class ErrorModalContainer extends Component <ErrorModalContainerProps, ErrorModalContainerState> {

  render() {
    let text: JSX.Element | string = ''
    if (this.props.errorModal.error) {
      const errorText = this.props.errorModal.error.response.data.split('{')
      const errorHumanText = errorText[0];
      const d = new Date();
       const date = moment(d).format('DD MMM YYYY HH:mm')
       text = <Fragment>
                <div style={{color: 'black', marginBottom: '10px'}}> {errorHumanText}</div>
                <div style={{}}>Technical details </div>
                <hr/>
                <div> Error: {this.props.errorModal.error.response.data}</div>
                <div>Server error code: {this.props.errorModal.error.response.status}</div>
                <div>Time: {date}</div>
                <div>Url: {this.props.errorModal.error.response.request.responseURL}</div>     
              </Fragment>
    }
    return (
      <Fragment>
        <ConfirmationDialog 
          title='Error' 
          text={ text }
          open={this.props.errorModal.opened}
          close={() => window.location.reload()}
          confirm={() => window.location.reload()}
          textConfirm='Refresh page'
          showCloseIcon={false}
          maxWidth='md'
        />
      </Fragment>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    errorModal: state.errorModal
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => dispatch(closeErrorModal())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModalContainer);